export const FALLBACK_COLOR = 'red';
export const GEO_TRACKING_FEATURE = 'geo-tracking-feature';
export const SUBMITTED_ACTIVITY_SHAPE = 'submitted-activity-shape';
